import { render } from "./CreateJournalist.vue?vue&type=template&id=533d40a4"
import script from "./CreateJournalist.vue?vue&type=script&lang=js"
export * from "./CreateJournalist.vue?vue&type=script&lang=js"

import "./CreateJournalist.vue?vue&type=style&index=0&id=533d40a4&lang=less"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__